

export class FuelCalibrationOutputWithStatus implements IFuelCalibrationOutputWithStatus {
    /** The auto-generated id of the fuel calibration master */
    fuel_calibration_id!: number;
    /** The branch name with 255 character */
    branch!: string;
    /** The company name with 255 character */
    company_name!: string;
    /** The property name with 255 character */
    port!: string;
    /** The vehicle name and number name with 255 character */
    vehicle!: string;
    /** The sensor output unit must be Voltage,Liter,Gallon,percentage */
    sensor_output_unit!: string;
    /** The range 50 character */
    range!: string;
    /** The conversion factor */
    conversion_factor!: number;
    /** The sensor output unit must be Automatic,Manual */
    calibration_type!: string;
    /** The tank capacity */
    tank_capacity!: number;
    /** The empty tank reading */
    empty_tank_reading!: number;
    /** The half tank reading */
    half_tank_reading!: number;
    /** The full tank reading */
    full_tank_reading!: number;
    /** The filled up liter */
    filled_up_liter!: number;
    /** Manage status of fuel calibration. 0 For De-active, 1 For Active */
    status!: number;

    constructor(data?: IFuelCalibrationOutputWithStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fuel_calibration_id = _data["fuel_calibration_id"];
            this.branch = _data["branch"];
            this.company_name = _data["company_name"];
            this.port = _data["port"];
            this.vehicle = _data["vehicle"];
            this.sensor_output_unit = _data["sensor_output_unit"];
            this.range = _data["range"];
            this.conversion_factor = _data["conversion_factor"];
            this.calibration_type = _data["calibration_type"];
            this.tank_capacity = _data["tank_capacity"];
            this.empty_tank_reading = _data["empty_tank_reading"];
            this.half_tank_reading = _data["half_tank_reading"];
            this.full_tank_reading = _data["full_tank_reading"];
            this.filled_up_liter = _data["filled_up_liter"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): FuelCalibrationOutputWithStatus {
        data = typeof data === 'object' ? data : {};
        let result = new FuelCalibrationOutputWithStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fuel_calibration_id"] = this.fuel_calibration_id;
        data["branch"] = this.branch;
        data["company_name"] = this.company_name;
        data["port"] = this.port;
        data["vehicle"] = this.vehicle;
        data["sensor_output_unit"] = this.sensor_output_unit;
        data["range"] = this.range;
        data["conversion_factor"] = this.conversion_factor;
        data["calibration_type"] = this.calibration_type;
        data["tank_capacity"] = this.tank_capacity;
        data["empty_tank_reading"] = this.empty_tank_reading;
        data["half_tank_reading"] = this.half_tank_reading;
        data["full_tank_reading"] = this.full_tank_reading;
        data["filled_up_liter"] = this.filled_up_liter;
        data["status"] = this.status;
        return data; 
    }
}

export interface IFuelCalibrationOutputWithStatus {
    /** The auto-generated id of the fuel calibration master */
    fuel_calibration_id: number;
    /** The branch name with 255 character */
    branch: string;
    /** The company name with 255 character */
    company_name: string;
    /** The property name with 255 character */
    port: string;
    /** The vehicle name and number name with 255 character */
    vehicle: string;
    /** The sensor output unit must be Voltage,Liter,Gallon,percentage */
    sensor_output_unit: string;
    /** The range 50 character */
    range: string;
    /** The conversion factor */
    conversion_factor: number;
    /** The sensor output unit must be Automatic,Manual */
    calibration_type: string;
    /** The tank capacity */
    tank_capacity: number;
    /** The empty tank reading */
    empty_tank_reading: number;
    /** The half tank reading */
    half_tank_reading: number;
    /** The full tank reading */
    full_tank_reading: number;
    /** The filled up liter */
    filled_up_liter: number;
    /** Manage status of fuel calibration. 0 For De-active, 1 For Active */
    status: number;
}

